'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '1.4.12';


//////////////////
// WEBPACK FOOTER
// ./~/places.js/src/version.js
// module id = 667
// module chunks = 1